<ion-header class="transparent pt-2 mt-1">
  <ion-toolbar class="page-title">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col">
            <div class="row">
              <div class="col-auto">
                <h1 class="fw-medium" style="font-size: 2rem">
                  @if (title) {
                    {{ title }}
                  }
                </h1>
              </div>
              <div class="col">
                <ng-content select="[slot=middle]"></ng-content>
              </div>
            </div>
          </div>
          <div class="col-auto ps-0">
            <ng-content select="[slot=end]"></ng-content>
          </div>
        </div>
      </div>

      @if (showBreadcum && homePage && homePage.currentOrganisation) {
        <div class="col-12 text-start">
          <div class="d-inline-block">
            <ion-breadcrumbs
              class="p-0"
              style="margin-left: -10px; margin-top: -10px"
            >
              @if (homePage.currentOrganisation.parent) {
                @if (
                  homePage.hasAccessToCompanies(
                    homePage.currentOrganisation.parent
                  )
                ) {
                  <ion-breadcrumb
                    class="pointer-hover"
                    (click)="
                      goToCompany(homePage!.currentOrganisation!.parent!)
                    "
                    >{{
                      homePage.currentOrganisation.parent.name
                    }}</ion-breadcrumb
                  >
                } @else {
                  <ion-breadcrumb>{{
                    homePage.currentOrganisation.parent.name
                  }}</ion-breadcrumb>
                }
              }
              <ion-breadcrumb
                class="pointer-hover"
                (click)="goToCompany(homePage!.currentOrganisation!)"
                >{{ homePage.currentOrganisation.name }}</ion-breadcrumb
              >
            </ion-breadcrumbs>
          </div>
        </div>
      }
    </div>

    <div slot="end"></div>
  </ion-toolbar>

  @if (menu) {
    <div class="d-block">
      <ion-segment
        [value]="getCurrentSegment()"
        class="horizontal-menu"
        [scrollable]="true"
        mode="ios"
        (ionChange)="onSegmentChange($event)"
      >
        @for (m of menu; track m) {
          <ion-segment-button [value]="m.uri">
            <ion-label>{{ m.name }}</ion-label>
          </ion-segment-button>
        }
      </ion-segment>
    </div>
  }
</ion-header>
